module.exports = __webpack_public_path__ + "img/p3_2.9639929f.png";